import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom'
import { Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useForm, Controller } from "react-hook-form";
import { formatDate } from "../utils/dateFormatter";

const ViewContract = () => {
    const navigate = useNavigate();
    const userUID = useSelector(state => state.user.uid);
    const userType = useSelector(state => state.user.userType);
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [garageInsurance, setGarageInsurance] = useState();

    const [selectedContractId, setSelectedContractId] = useState(null);

    const {
        control: control1,
        register: register1,
        handleSubmit: handleSubmit1,
        formState: { errors: errors1 },
    } = useForm();

    const {
        control: control2,
        register: register2,
        handleSubmit: handleSubmit2,
        formState: { errors: errors2 },
    } = useForm();
    const {
        control: control3,
        register: register3,
        handleSubmit: handleSubmit3,
        formState: { errors: errors3 },
    } = useForm();


    useEffect(() => {
        if (userUID !== 'none') {
            axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'GetAllContract', userUID: userUID, userType: userType })
                .then(response => {
                    setData(response.data.data);
                    console.log("response", response.data.data);
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        }
    }, [userUID, userType]);

    // const handleActionClick = (id) => {
    //     console.log(`Action clicked for id: ${id}`);
    // };

    const ViewContract = (id) => {
        navigate(`/readcontract/${id}`);
        return console.log(`Action clicked for id: ${id}`);
    };

    const EditContract = (id) => {
        navigate(`/leaseformedit/${id}`);
        return console.log(`Action clicked for id: ${id}`);
    };

    const filteredData = data.filter((item) =>
        item && typeof item.garageAddress === 'string' && item.garageAddress.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const displayedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };



    // const accpetContract = (item) => {
    //     console.log(item)
    // }


    const onSubmit = async (data) => {
        try {
            Swal.fire({
                title: 'Updating, please wait',
                html:
                    '<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
                showConfirmButton: false,
                showCancelButton: false,
                focusConfirm: false,
            });
            const res = await axios.post(`${process.env.REACT_APP_API_URL}`, {
                action: 'ContractRejectByTenant',
                id: selectedContractId,
                message: data.rejectionReason
            });
            if (res.data.status === true) {

                Swal.fire(
                    'Rejected!',
                    'The contract has been rejected.',
                    'success'
                ).then(() => {
                    window.location.reload();
                })

            } else {
                Swal.fire({
                    title: 'Alert',
                    text: res.data.message,
                    icon: 'error',
                });
            }
        } catch (err) {
            console.log(err);
            Swal.fire(
                'Error!',
                'An error occurred while rejecting the contract.',
                'error'
            );
        }
    };
    const handleRejectContract = async (data) => {

        try {

            Swal.fire({
                title: 'Updating, please wait',
                html:
                    '<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
                showConfirmButton: false,
                showCancelButton: false,
                focusConfirm: false,
            });
            const res = await axios.post(`${process.env.REACT_APP_API_URL}`, {
                action: 'SignedContractRejectByOwner',
                id: selectedContractId,
                message: data.rejectionReason
            });
            if (res.data.status === true) {
                Swal.fire(
                    'Rejected!',
                    'The contract has been rejected.',
                    'success'
                ).then(() => {
                    window.location.reload();
                })

            } else {
                Swal.fire({
                    title: 'Alert',
                    text: res.data.message,
                    icon: 'error',
                });
            }
        } catch (err) {
            console.log(err);
            Swal.fire(
                'Error!',
                'An error occurred while rejecting the contract.',
                'error'
            );
        }
    };


    const handleAcceptSignedContract = async (ContractId) => {
        Swal.fire({
            title: 'Are you sure?',
            text: `You want to Start contract!`,
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: `Yes, Start it!`
        }).then(async (result) => {
            if (result.value) {
                try {

                    Swal.fire({
                        title: 'Updating, please wait',
                        html:
                            '<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
                        showConfirmButton: false,
                        showCancelButton: false,
                        focusConfirm: false,
                    });
                    const res = await axios.post(`${process.env.REACT_APP_API_URL}`, {
                        action: 'SignedContractAcceptByOwner',
                        id: ContractId
                    });
                    if (res.data.status === true) {
                        Swal.fire(
                            'Started!',
                            'The contract has been Started.',
                            'success'
                        ).then(() => {
                            window.location.reload();
                        })

                    } else {
                        Swal.fire({
                            title: 'Alert',
                            text: res.data.message,
                            icon: 'error',
                        });
                    }
                } catch (err) {
                    console.log(err);
                    Swal.fire(
                        'Error!',
                        'An error occurred while Starting the contract.',
                        'error'
                    );
                }
            }
        })
    }


    const OpenModal = (id, modalid) => {
        setSelectedContractId(id);
        document.getElementById(modalid).classList.add('show');
        document.getElementById(modalid).style.display = 'block';
    };

    const closeModal = (modalid) => {
        document.getElementById(modalid).classList.remove('show');
        document.getElementById(modalid).style.display = 'none';
        setSelectedContractId(null);
    };

    const handleAcceptModalSubmit = async (data) => {

        Swal.fire({
            title: 'Updating, please wait',
            html:
                '<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
            showConfirmButton: false,
            showCancelButton: false,
            focusConfirm: false,
        });
        const formData = new FormData();
        formData.append('action', 'ContractAcceptByTenant');
        formData.append('id', selectedContractId);
        formData.append('sampleContract', data.acceptfile);

        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            if (res.data.status === true) {
                console.log(res.data);
                Swal.fire(
                    'Accepted!',
                    'The contract has been accepted.',
                    'success'
                ).then(() => {
                    navigate(0);
                })

            } else {
                Swal.fire({
                    title: 'Alert',
                    text: res.data.message,
                    icon: 'error',
                });
            }
        } catch (err) {
            console.log(err);
            Swal.fire(
                'Error!',
                'An error occurred while accepting the contract.',
                'error'
            )
        }
    };


    // const viewSignedPDF = (item) => {
    //     const completePDFPath = `${process.env.REACT_APP_API_URL}${item}`;
    //     window.open(completePDFPath, '_blank');
    // };


    const viewPayment = (item) => {
        navigate(`/viewpayment/${item}`);
    }

    // const payNow = () => {

    //     navigate(`/garage-payment`);
    // }

    const payNow = (contractId) => {

        localStorage.setItem('add_payment', JSON.stringify(contractId));
        navigate('/garage-payment');
        // const formAlldata = {
        //     datebaseid: contractId,
        //     action: "GarageAddRecurringPayment"
        // };
        // axios.post(`${process.env.REACT_APP_API_URL}stripe.php`, formAlldata)
        //     .then((response22) => {
        //         if (response22.data.status === true) {
        //             localStorage.setItem('add_payment', JSON.stringify(response22.data.datebaseid));
        //             localStorage.setItem('orderId', JSON.stringify(response22.data.order_id));
        //             navigate('/garage-payment');

        //         } else {
        //             Swal.fire(
        //                 'Error!',
        //                 'Error: ' + response22.data.message,
        //                 'error'
        //             );
        //         }

        //     })
        //     .catch((error) => {
        //         console.error('Error fetching client secret:', error);
        //     });


        // navigate('/garage-payment', {
        //     state: {
        //         id: id,
        //         garageID: garageID,
        //         deposit: deposit
        //     }
        // });
    };



    const profile_complete = useSelector(state => state.user.profile_complete);
    useEffect(() => {
        if (profile_complete != true) {
            navigate('/edit_user');
            Swal.fire({
                icon: 'info',
                title: 'Please complete your profile first.',
            });
        }
    }, [profile_complete]);


    return (
        <section className="page-content sec-padding">
            <div className="container-fluid">
                <div className='row'>
                    <div className="col-md-12 d-flex">
                        <input
                            className='form-control w-25 mx-2 py-2'
                            placeholder="Search Contract"
                            type="text"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>
                    <div className="table-responsive-xxl">
                        <table className='table table-hover'>
                            <thead>
                                <tr className='bg-primary'>
                                    <th>Garage Details</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData && filteredData.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.garageAddress}</td>
                                        <td>{item.startdate ? formatDate(item.startdate) : formatDate(item.start_date)}</td>
                                        <td>{item.enddate ? formatDate(item.enddate) : formatDate(item.end_date)}</td>
                                        <td>${item.currentProposal}</td>
                                        <td>
                                            {/* {item.contractStatus} */}
                                            {userType === "Tenant" ? (
                                                <>
                                                    {item.contractStatus === null &&
                                                        <small className="text-danger">Contract Under Review.</small>
                                                    }
                                                    {item.contractStatus === 0 &&
                                                        <small className="text-danger">Contract Under Review. Action Pending from Owner side</small>
                                                    }
                                                    {item.contractStatus === 1 &&
                                                        <small className="text-danger">Waiting for Accept/Reject</small>
                                                    }
                                                    {item.contractStatus === 2 &&
                                                        <small className="text-warning">Contract Rejected</small>
                                                    }
                                                    {item.contractStatus === 3 &&
                                                        <small className="text-warning">Contract Accepted. You need to wait for <br />Onwer accept o reject your signed contract</small>
                                                    }
                                                    {item.contractStatus === 4 &&
                                                        <small className="text-warning">Rejected by Owner.You need to upload again.</small>
                                                    }
                                                    {item.contractStatus === 5 &&
                                                        <small className="text-success">Contract Started</small>
                                                    }
                                                    {item.contractStatus === 6 &&
                                                        <small className="text-danger">Subscription Canceled</small>
                                                    }
                                                </>
                                            )
                                                : (
                                                    <>
                                                        {item.contractStatus === null &&
                                                            <small className="text-danger">Contract Under Review.</small>
                                                        }
                                                        {item.contractStatus === 0 &&
                                                            <small className="text-danger">Please Submit Contract to Tenant.</small>
                                                        }
                                                        {item.contractStatus === 1 &&
                                                            <small className="text-danger">Waiting for Accept/Reject</small>
                                                        }
                                                        {item.contractStatus === 2 &&
                                                            <small className="text-warning">Contract Rejected</small>
                                                        }
                                                        {item.contractStatus === 3 &&
                                                            <small className="text-warning">You need to Reject/ Start Signed Contract</small>
                                                        }
                                                        {item.contractStatus === 4 &&
                                                            <small className="text-warning">Rejected by Owner.</small>
                                                        }
                                                        {item.contractStatus === 5 &&
                                                            <small className="text-success">Contract Started</small>
                                                        }
                                                        {item.contractStatus === 6 &&
                                                            <small className="text-danger">Subscription Canceled</small>
                                                        }
                                                    </>
                                                )
                                            }
                                        </td>
                                        <td className='d-flex align-items-center'>

                                            {userType === "Tenant" ? (
                                                <>
                                                    <Link to={`/garages-details/${item.garageidenc}`}
                                                        className='btn me-2 btn-primary'>Garage Details</Link>


                                                    {item.contractStatus >= 1 &&
                                                        <button onClick={() => ViewContract(item.contractId)}
                                                            className='btn me-2 btn-primary'>View Contract</button>}

                                                    {item.contractStatus === 4 &&

                                                        <button onClick={() => OpenModal(item.contractId, 'pdfPreviewModalAccept')}
                                                            className='btn me-2 btn-primary'>Upload Contract</button>
                                                    }

                                                    {item.contractStatus === 1 &&
                                                        <button onClick={() => OpenModal(item.contractId, 'pdfPreviewModalAccept')}
                                                            className='btn me-2 btn-primary'>Accept Contract</button>}

                                                    {(item.contractStatus === 1 || item.contractStatus === 4) &&
                                                        <button onClick={() => OpenModal(item.contractId, 'pdfPreviewModalTwo')}
                                                            className='btn me-2 btn-primary'>Reject Contract</button>}

                                                    {item.contractStatus === 0 || item.contractStatus === 2 &&
                                                        <button disabled className='btn me-2 btn-primary'>
                                                            <p>Your Request is Under Review</p>
                                                        </button>}

                                                    {(item.contractStatus === 5 || item.contractStatus === 3 || item.contractStatus === 4) &&
                                                        <button onClick={() => [OpenModal(item.contractId, 'viewSignedPDF'),
                                                        setGarageInsurance(`${process.env.REACT_APP_API_URL}${item.sign_contract}`)]}
                                                            className='btn me-2 btn-primary'>View Signed Contract</button>}

                                                    {(item.contractStatus === 5 || item.contractStatus === 6) && (
                                                        <>
                                                            {item.allpayments && item.allpayments.status == '1' ?
                                                                (<button onClick={() => viewPayment(item.contractId)}
                                                                    className='btn me-2 btn-primary'>View payments</button>)
                                                                :
                                                                (
                                                                    <button onClick={() => payNow(item.contractId)}
                                                                        className='btn me-2 btn-primary'>Pay Now</button>
                                                                )}
                                                        </>
                                                    )}


                                                </>
                                            ) : (
                                                <>
                                                    <Link to={`/garages-details/${item.garageidenc}`}
                                                        className='btn me-2 btn-primary'>Garage Details</Link>

                                                    {item.contractStatus === null &&
                                                        <Link to={`/leaseform/${item.NegoId}`}
                                                            className='btn me-2 btn-primary'>Edit Contract</Link>}
                                                    {item.contractStatus === 0 &&
                                                        <button onClick={() => EditContract(item.contractId)}
                                                            className='btn me-2 btn-primary'>Edit Contract</button>}

                                                    {item.contractStatus === 2 &&
                                                        <button onClick={() => EditContract(item.contractId)}
                                                            className='btn me-2 btn-primary'>Tenent Rejected /Edit Contract</button>}

                                                    {item.contractStatus >= 1 &&
                                                        <button onClick={() => ViewContract(item.contractId)}
                                                            className='btn me-2 btn-primary'>View Contract</button>}

                                                    {item.contractStatus === 3 &&
                                                        <button onClick={() => handleAcceptSignedContract(item.contractId)}
                                                            className='btn me-2 btn-primary'>Start Contract</button>}

                                                    {item.contractStatus === 3 &&
                                                        <button onClick={() => OpenModal(item.contractId, 'RejectSignedContract')}
                                                            className='btn me-2 btn-primary'>Reject Signed Contract</button>}


                                                    {(item.contractStatus === 5 || item.contractStatus === 3 || item.contractStatus === 4) &&
                                                        <button onClick={() => [OpenModal(item.contractId, 'viewSignedPDF'),
                                                        setGarageInsurance(`${process.env.REACT_APP_API_URL}${item.sign_contract}`)]}
                                                            className='btn me-2 btn-primary'>View Signed Contract</button>}


                                                    {(item.contractStatus === 5 || item.contractStatus === 6) &&
                                                        item.allpayments && item.allpayments.status == '1' &&
                                                        <button onClick={() => viewPayment(item.contractId)}
                                                            className='btn me-2 btn-primary'>View payments</button>}
                                                </>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <button onClick={handlePreviousPage} disabled={currentPage === 1} className='btn btn-primary'>Previous</button>
                        <span> Page {currentPage} of {totalPages} </span>
                        <button onClick={handleNextPage} disabled={currentPage === totalPages} className='btn btn-primary'>Next</button>
                    </div>
                </div>
            </div>

            {/* Modal for rejection reason */}
            <div className="modal fade" id="pdfPreviewModalTwo" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Reject Contract</h5>
                            <button type="button" className="btn-close  close" data-dismiss="modal" aria-label="Close" onClick={() => closeModal('pdfPreviewModalTwo')}>
                                <span aria-hidden="true"></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit2(onSubmit)}>
                                <div className="form-group row">
                                    <label className="form-label col-md-4" htmlFor="rejectionReason">Reason for Rejection:</label>
                                    <div className="col-md-8 d-flex position-relative">
                                        <input
                                            className="form-control" rows={3}
                                            name='rejectionReason'
                                            {...register2("rejectionReason", { required: true })}
                                        />
                                        {errors2.rejectionReason &&
                                            <span className="text-danger la la-exclamation-circle error-icon">
                                                <span className="badge badge-danger error-icon-text">Reason for Rejection is Required</span>
                                            </span>
                                        }
                                    </div>
                                </div>
                                <div className="form-group text-center">
                                    <button type="button" className="btn btn-secondary me-3" onClick={() => closeModal('pdfPreviewModalTwo')}>Cancel</button>
                                    <button type="submit" className="btn btn-primary">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="pdfPreviewModalAccept" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Accept Contract</h5>
                            <button type="button" className="btn-close  close" data-dismiss="modal" aria-label="Close" onClick={() => closeModal('pdfPreviewModalAccept')}>
                                <span aria-hidden="true"></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit1(handleAcceptModalSubmit)}>
                                <div className="form-group row">
                                    <label className="form-label col-md-4" htmlFor="acceptfile">Upload Signed Contract (PDF):</label>
                                    <div className="col-md-8 d-flex position-relative">
                                        <Controller
                                            name="acceptfile"
                                            control={control1}
                                            rules={{ required: true }}
                                            render={({ field }) => (
                                                <>
                                                    <input
                                                        ref={field.ref}
                                                        id="acceptfile"
                                                        type="file"
                                                        className="form-file form-control"
                                                        accept=".pdf"
                                                        onChange={(e) => {
                                                            field.onChange(e.target.files[0]);
                                                        }}
                                                    />
                                                    <label htmlFor="acceptfile" className="btn btn-primary btn-lg">Choose a File</label>
                                                    {errors1.acceptfile &&
                                                        <span className="text-danger la la-exclamation-circle error-icon">
                                                            <span className="badge badge-danger error-icon-text">Upload Signed Contract (PDF) is required</span>
                                                        </span>
                                                    }
                                                </>
                                            )}
                                        />
                                    </div>
                                </div>
                                <div className="form-group text-center">
                                    <button type="button" className="btn btn-secondary me-3" data-dismiss="modal" onClick={() => closeModal('pdfPreviewModalAccept')}>Cancel</button>
                                    <button type="submit" className="btn btn-primary">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>


            <div className="modal fade" id="RejectSignedContract" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-xxl" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Reject Contract</h5>
                            <button type="button" className="btn-close  close" data-dismiss="modal" aria-label="Close" onClick={() => closeModal('RejectSignedContract')}>
                                <span aria-hidden="true"></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit3(handleRejectContract)}>
                                <div className="form-group row">
                                    <label className="form-label col-md-4" htmlFor="rejectionReason">Reason for Rejection:</label>
                                    <div className="col-md-8 d-flex position-relative">
                                        <input
                                            className="form-control" rows={3}
                                            name='rejectionReason'
                                            {...register3("rejectionReason", { required: true })}
                                        />
                                        {errors3.rejectionReason &&
                                            <span className="text-danger la la-exclamation-circle error-icon">
                                                <span className="badge badge-danger error-icon-text">Reason for Rejection is Required</span>
                                            </span>
                                        }
                                    </div>
                                </div>
                                <div className="form-group text-center">
                                    <button type="button" className="btn btn-secondary me-3" data-dismiss="modal" onClick={() => closeModal('RejectSignedContract')}>Cancel</button>
                                    <button type="submit" className="btn btn-primary">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="viewSignedPDF" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-xxl" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Preview SignedPdf</h5>

                            <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={() => closeModal('viewSignedPDF')}>
                                <span aria-hidden="true"></span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <embed src={garageInsurance} type="application/pdf" width="100%" height="500px" />
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => closeModal('viewSignedPDF')}>Close</button>
                        </div>
                    </div>
                </div>
            </div>

        </section >
    );
};

export default ViewContract;
